// extracted by mini-css-extract-plugin
export var childrenContainer = "_bk-0";
export var virtualScrollArea = "_bk-1";